<template>
  <div class="box-wrapper">
    <div class="box">
      <div class="box-header">
        <span class="title">{{title}}</span>
        <div class="icons">
          <el-radio-group v-model="viewType">
            <el-radio-button label="line"><i class="far fa-chart-line"></i></el-radio-button>
            <el-radio-button label="area"><i class="fas fa-chart-area"></i></el-radio-button>
          </el-radio-group>
            <el-button @click="showChartSettingPopup"><i class="fas fa-cog"></i>변경</el-button>
        </div>
      </div>
      <div v-if="isCardDataList" class="box-content2" v-loading="isLoading">
        <el-carousel  :interval="10000" trigger="click" @change="onChangeCarousel" arrow="never" :indicator-position="(checkDataList.length > 1) ? 'outside' : 'none'" :autoplay="active">
          <el-carousel-item v-for="(item, index) in checkDataList" :key="`${widgetPosition}-${index}`">
              <w-perf-root-chart class="mr-b4" :ref="`perfRootChart-${widgetPosition}`" :viewType="viewType"></w-perf-root-chart>
                <el-table-wrapper :column-default="columnDefault" :data="tableData" :columns="perfTableColumns" :pagination="false"
                  :show-custom-header="true" :show-search-tool="false" header-align="left" highlight-current-row>
                  <template #bar-slot="scope">
                    <el-progress :text-inside="true" :percentage="scope.row.value"></el-progress>
                  </template>
                  <template #textlink-slot="scope">
                    <span class="link" @click="onClickTableNode(scope.row)">{{scope.row.label}}</span>
                  </template>
                </el-table-wrapper>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="box-content2" v-else>
          <div class="chart-area"></div>
            <div class="steps" style="width: 49.5%; margin-right: 1%">
                <div class="step_num">1</div>
                <div class="step one"></div>
            </div>
            <div class="steps" style="width: 49.5%">
                <div class="step_num">2</div>
                <div class="step two"></div>
            </div>
          <div class="btn-container">
            <el-button size="small" @click="showChartSettingPopup">성능자원 선택</el-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import perfApi from '@/api/performance/root';
import { isEmpty, isNil, cloneDeep } from 'lodash';
import moment from 'moment';
import { columnDefault } from '@/constants/table';
import { EMPTY_TEXT } from '@/utils/string';
import { convertValuByUnit } from '@/utils/number';
import { routePathByObjId } from '@/utils/router';
import { menuDefine } from '@/constants/menu';
import { performanceNodeTabs } from '@/constants/performance';

import WPerfRootChart from './chart/PerfRootChart';

export default {
  name: 'WsummaryperfTopCard',
  components: {
    WPerfRootChart,
  },
  props: {
    widgetPosition: {
      type: Number,
    },
    active: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters(['selectedNode']),
  },
  watch: {
    active() {
      if (this.active) {
        this.loadData();
      }
    },
    selectedNode() {
      if (this.active) {
        this.loadData();
      }
    },
    index() {
      this.loadCardData();
    },
  },
  data() {
    return {
      tableColumns: {
        SMS: [
          { prop: 'label', label: '관리대상명', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        NMS: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        DBMS: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
          { prop: 'dbPort', label: '포트', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        FMS: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        E2E: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'e2eUrl', label: 'URL', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        VMS: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'vmsType', label: '가상화 종류', headerAlign: 'left', showOverflowTooltip: true },
        ],
        SVC: [
          { prop: 'label', label: '인스턴스명', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        NMSINTERFACE: [
          { prop: 'label', label: '인터페이스명', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: '인터페이스 IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
        APM2X: [
          { prop: 'label', label: '관리대상', headerAlign: 'left', scopedSlot: 'textlink-slot', showOverflowTooltip: true },
          { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter, showOverflowTooltip: true },
        ],
      },
      viewType: 'line',
      title: '',
      columnDefault,
      tableData: [],
      selectType: '',
      perfTableColumns: [],
      checkDataList: [],
      chartData: [],
      activeRscData: null,
      index: 0,
      isCardDataList: false,
      isLoading: false,
    };
  },
  methods: {
    onClickTableNode(data) {
      let objId = data.objId;
      if (this.activeRscData.managetypeId === 'E2E') {
        objId = data.rsckey.split('.')[1];
      }
      routePathByObjId(this, objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name);
    },
    convertValue(data) {
      let unit = data.unit;
      if (data.unit === 'count') {
        unit = '개';
      } else if (data.unit === 'KB' || data.unit === 'MB' || data.unit === 'GB') {
        unit = 'Byte';
      }
      return `${convertValuByUnit(data.value, data.unit, false, false, true)}${unit}`;
    },
    /**
     * 카드 이동 시 설정된 TOP 5 데이터를 조회 한다.
     * @author leesy918
     * @param  {[type]} index [description]
     * @return {[type]}       [description]
     */
    onChangeCarousel(index) {
      this.index = index;
      this.activeRscData = this.checkDataList[index];
      if (!isEmpty(this.activeRscData)) {
        this.title = `[${this.activeRscData.managetypeName}] ${this.activeRscData.rsctypeName} TOP 5`;
      }
    },
    loadData(widgetPosition) {
      if (!isNil(widgetPosition) && widgetPosition !== this.widgetPosition) {
        return;
      }
      this.isLoading = true;
      this.perfTableColumns = [];
      const params = {
        widgetPosition: this.widgetPosition,
      };
      perfApi.getPerfChartSetting(params).then((response) => {
        if (response.data.success) {
          if (!isEmpty(response.data.data)) {
            this.isCardDataList = true;
            this.checkDataList = response.data.data;
            this.activeRscData = this.checkDataList[0];
            this.title = `[${this.activeRscData.managetypeName}] ${this.activeRscData.rsctypeName} TOP 5`;
            this.$nextTick(() => {
              this.loadCardData();
            });
          } else {
            this.isCardDataList = false;
            this.title = '성능 정보 TOP5 샘플예제';
          }
        }
      });
    },
    /**
     * TOP 5 테이블 데이터 조회
     * @author leesy918
     * @return {[type]} [description]
     */
    loadCardData() {
      this.perfTableColumns = [];
      const params = this.setParam();
      perfApi.getPerfTopCardData(params).then((response) => {
        if (response.data.success) {
          if (!isNil(response.data.data)) {
            const tableData = response.data.data.tableData;
            const chartData = response.data.data.chartData;
            this.$nextTick(() => {
              const chartRef = this.$refs[`perfRootChart-${this.widgetPosition}`];
              chartRef[this.index].setData(chartData);
            });
            this.tableData = tableData;
            let item = {};
            if (!isEmpty(this.tableData)) {
              if (this.tableData[0].unit !== '%') {
                item = {
                  label: this.tableData[0].rscName,
                  formatter: this.convertValue,
                  prop: 'value',
                  headerAlign: 'left',
                };
              } else {
                item = {
                  label: this.tableData[0].rscName,
                  scopedSlot: 'bar-slot',
                  prop: 'value',
                  headerAlign: 'left',
                };
              }
            }
            if (this.activeRscData.managetypeId === 'NMS' && this.activeRscData.managetypeKey === 'NI') {
              this.perfTableColumns = cloneDeep(this.tableColumns.NMSINTERFACE);
            } else {
              this.perfTableColumns = cloneDeep(this.tableColumns[this.activeRscData.managetypeId]);
            }
            if (this.activeRscData.managetypeId === 'VMS' && (this.activeRscData.managetypeKey === 'VHO' || this.activeRscData.managetypeKey === 'VVM')) {
              const ipItem = { prop: 'ipaddress', label: 'IP', headerAlign: 'left', formatter: this.getStringFormatter };
              this.perfTableColumns.push(ipItem);
            }
            this.$nextTick(() => {
              this.perfTableColumns.push(item);
            });
          }
        }
      }).finally(() => {
        this.isLoading = false;
      });
    },
    setParam() {
      const params = {
        managetypeId: this.activeRscData.managetypeId,
        managetypeKey: this.activeRscData.managetypeKey,
        rscId: this.activeRscData.rscId,
        rsctypeId: this.activeRscData.rsctypeId,
        selectedObjType: 'multi',
        limit: 5,
        objTotal: false,
        order: 'top',
        selectType: 'OBJ',
        endDatetime: moment().toDate(),
        startDatetime: moment().subtract(1, 'hours').toDate(),
        rscInfoList: [
          { rscId: this.activeRscData.rscId, rsctypeId: this.activeRscData.rsctypeId },
        ],
      };
      return params;
    },
    getStringFormatter(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    showChartSettingPopup() {
      this.$emit('showChartSettingPopup', this.widgetPosition);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/SummaryPerfTopCard.vue